export default "__VITE_ASSET__CQYqZr70__"